<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <section class="section white-panel mb2p pt24">
          <h2 class="fs16 bdb-solid-gradient1 pb8 mb8">定額整備対象部品の一覧と整備基準</h2>
          <p class="fs13">以下の定額整備の対象部品について、当社規定の整備基準に従い定額で整備させていただきます。 整備基準は法定点検基準に準拠し異常のある箇所は全て交換・整備を行います。加えて、エンジン・ブレーキ関連部品は、異常がない場合でもメーカー等の基準に準拠した予防交換を実施させていただいております。</p>

          <section>
            <dl class="dl dl-l dt65-dd35 dl-toggle mt24 mb24 pr0">
              <dt class="fs12 color-font1 pb8" style="border-bottom: 2px solid #D3D9DF;"><strong>定額整備対象部品</strong></dt>
              <dd class="fs12 text-left color-font1 pb8" style="border-bottom: 2px solid #D3D9DF;"><strong>整備基準</strong></dd>
              <dd class="child">
                <table class="fs13 mt12 text-left">
                  <tbody>
                    <tr class="">
                      <td colspan="3" class="pt12 pb12 color-font2">予防交換する部品</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4">1</td>
                      <td class="pt4 pb4">ブレーキフルード</td>
                      <td class="pt4 pb4 text-right">2年以上経過</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4">2</td>
                      <td class="pt4 pb4">ブレーキライニング・シュー</td>
                      <td class="pt4 pb4 text-right">摩擦材2ｍｍ以下</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4">3</td>
                      <td class="pt4 pb4">ブレ－キパット</td>
                      <td class="pt4 pb4 text-right">摩擦材3ｍｍ以下</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4">4</td>
                      <td class="pt4 pb4">エンジンオイル</td>
                      <td class="pt4 pb4 text-right">半年以上経過</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4">5</td>
                      <td class="pt4 pb4">オイルエレメント</td>
                      <td class="pt4 pb4 text-right">オイル交換2回に1回</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4">6</td>
                      <td class="pt4 pb4">バッテリー</td>
                      <td class="pt4 pb4 text-right">3年以上経過(ハイブリッド車の補機バッテリーは5年。保証期間が3年以上の場合は保証期間に準拠)</td>
                    </tr>
                    <tr class="">
                      <td colspan="3" class="pt12 pb12 color-font2">異常があれば交換する部品</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4">1</td>
                      <td class="pt4 pb4">電球</td>
                      <td class="pt4 pb4 text-right">切れたら</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4">2</td>
                      <td class="pt4 pb4">ヘッドライトコート</td>
                      <td class="pt4 pb4 text-right">ロービーム1灯あたり6400cd未満</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">3</td>
                      <td class="pt4 pb4">発炎筒</td>
                      <td class="pt4 pb4 text-right">使用期限超過時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">4</td>
                      <td class="pt4 pb4">ワイパーブレード</td>
                      <td class="pt4 pb4 text-right">ふき残し・ひび割れ発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">5</td>
                      <td class="pt4 pb4">ミッションオイル(ATF/CVTF)</td>
                      <td class="pt4 pb4 text-right">油色変化・劣化時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">6</td>
                      <td class="pt4 pb4">デフオイル </td>
                      <td class="pt4 pb4 text-right">油色変化・劣化時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">7</td>
                      <td class="pt4 pb4">クラッチオイル</td>
                      <td class="pt4 pb4 text-right">油色変化・劣化時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">8</td>
                      <td class="pt4 pb4">パワステフルード</td>
                      <td class="pt4 pb4 text-right">油色変化・劣化時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">9</td>
                      <td class="pt4 pb4">LLC</td>
                      <td class="pt4 pb4 text-right">液量低下、液色変化時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">10</td>
                      <td class="pt4 pb4">ラジエターバルブ</td>
                      <td class="pt4 pb4 text-right">異音、緩み、亀裂発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">11</td>
                      <td class="pt4 pb4">ラジエーター本体</td>
                      <td class="pt4 pb4 text-right">液漏れあり</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">12</td>
                      <td class="pt4 pb4">エアーエレメント</td>
                      <td class="pt4 pb4 text-right">異音、目詰まり</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">13</td>
                      <td class="pt4 pb4">スパークプラグ</td>
                      <td class="pt4 pb4 text-right">異常発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">14</td>
                      <td class="pt4 pb4">Vベルト</td>
                      <td class="pt4 pb4 text-right">異音、緩み、亀裂発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">15</td>
                      <td class="pt4 pb4">ハブベアリング</td>
                      <td class="pt4 pb4 text-right">異音、ガタつき発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">16</td>
                      <td class="pt4 pb4">ステアリングギアボックス</td>
                      <td class="pt4 pb4 text-right">液漏れあり</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">17</td>
                      <td class="pt4 pb4">ステアリングブーツ</td>
                      <td class="pt4 pb4 text-right">亀裂・グリス漏れ発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">18</td>
                      <td class="pt4 pb4">ドライブシャフトブーツ</td>
                      <td class="pt4 pb4 text-right">亀裂・グリス漏れ発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">19</td>
                      <td class="pt4 pb4">タイロットエンドブーツ</td>
                      <td class="pt4 pb4 text-right">亀裂・グリス漏れ発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">20</td>
                      <td class="pt4 pb4">スタビライザーリンク</td>
                      <td class="pt4 pb4 text-right">油滴・液漏れ発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">21</td>
                      <td class="pt4 pb4">ロアアームブーツ</td>
                      <td class="pt4 pb4 text-right">亀裂・グリス漏れ発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">22</td>
                      <td class="pt4 pb4">プロペラシャフト</td>
                      <td class="pt4 pb4 text-right">亀裂・損傷発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">23</td>
                      <td class="pt4 pb4">ショックアブソーバー</td>
                      <td class="pt4 pb4 text-right">油滴・液漏れあり</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">24</td>
                      <td class="pt4 pb4">ブレーキドラム</td>
                      <td class="pt4 pb4 text-right">亀裂・損傷発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">25</td>
                      <td class="pt4 pb4">ホイールシリンダー</td>
                      <td class="pt4 pb4 text-right">亀裂・損傷発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">26</td>
                      <td class="pt4 pb4">ディスクローター</td>
                      <td class="pt4 pb4 text-right">亀裂・損傷発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">27</td>
                      <td class="pt4 pb4">ディスクキャリパー</td>
                      <td class="pt4 pb4 text-right">亀裂・損傷発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">28</td>
                      <td class="pt4 pb4">ブレーキホース</td>
                      <td class="pt4 pb4 text-right">亀裂・液漏れ発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">29</td>
                      <td class="pt4 pb4">マフラーコート</td>
                      <td class="pt4 pb4 text-right">錆による腐食の発生時</td>
                    </tr>
                    <tr class="bdb-solid-gray3">
                      <td class="pt4 pb4 pr4">30</td>
                      <td class="pt4 pb4">下回り塗装</td>
                      <td class="pt4 pb4 text-right">錆による腐食の発生時</td>
                    </tr>
                    <tr class="">
                      <td colspan="3" class="pt12 pb12 color-font2">※一部のエリアにおいては、22、23、26、27、29、30は対象外<br>※HV車の場合、定額対象は補機バッテリーのみとなります。また、バッテリーの定額対象は1個となります。複数バッテリーが搭載されている車種の場合は劣化の激しいバッテリー1個のみ定額対象となり、2個目以降の交換が必要な場合は定額対象外になりますのでご了承願います。</td>
                    </tr>
                  </tbody>
                </table>
              </dd>
            </dl>

          </section>

        </section>

        <section class="section white-panel mb2p pt24">
          <h2 class="fs16 bdb-solid-gradient1 pb8 mb8">保証内容</h2>
          <p class="fs13">車検後半年または走行距離1万キロ以内に整備対象36部品で異常が発生した場合は無料で整備・交換を実施させていただきます。保証内容詳細は利用規約をご確認ください。 また、車検１年後の法定12ヶ月点検についても、無料でご案内しております。</p>
        </section>

        <section class="section white-panel mb2p pt24">
          <h2 class="fs16 bdb-solid-gradient1 pb8 mb8">コミっと車検利用規約</h2>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第1条（総則）</h3>
            <ol class="ol-count fs13">
              <li>本規約は、コスモ石油マーケティング株式会社（以下「当社」という。）が管理するアプリ（以下「本アプリ」という。）上で提供する車検サービス（以下「本サービス」といい、その名称を「コミっと車検」という。）に関し、本サービスを利用される方（以下「利用者」という）が遵守すべき事項および利用者と当社との関係を定めるものです。なお、本規約における「車検」とは、道路運送車両法第62条に定められた、自動車検査証の有効期限が満了した後も引き続きその自動車を使用するときに受ける検査のことをいいます。</li>
              <li>利用者は、本規約の他、本規約に付随して当社が定める規定、各種ガイドライン、マニュアル等（以下総称して「本規約等」といい、本アプリの利用規約を含む）を遵守するものとします。</li>
              <li>利用者が本規約等に違反した場合、当社は当該利用者に対し、サービス提供の停止、利用資格の取消、その他当社が必要と判断する一切の措置を講じることができるものとします。また、本規約等に違反した利用者の本アプリの利用資格を取り消すことができるものとします。</li>
              <li>当社は、利用者が本サービスを利用した場合、当該利用者は本規約等に同意したものとみなします。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第2条（本サービスの内容）</h3>
            <ol class="ol-count fs13">
              <li>本規約等において、利用者が受けることができるサービスの内容は、次の通りとします。
                <p class="mb0">1） 本アプリ上での車検金額の事前見積り</p>
                <p class="mb0">2） 車検に関する点検、整備、修理、通検</p>
                <p class="mb0">3） 納車時の整備内容説明</p>
                <p class="mb0">4） 車検後の整備保証</p>
              </li>
              <li>利用者は、アプリ上で事前見積りを行った後、車検対象となっている自動車等（以下「対象車両」という）を指定した店舗(以下、受付店舗という)に持ち込みます。受付店舗では引き受け時に店頭で対象車両を点検し、整備作業と見積金額を確定します。見積金額確定後、受付店舗または受付店舗が指定する整備工場にて対象車両の点検・整備作業、及び通検手続きを行います。</li>
              <li>本サービスは、当社が別途「定額整備対象品目」にて定める整備対象品目(以下、定額整備対象品目という)の整備、部品交換費用については、原則定額制です。</li>
              <li>定額整備対象品目以外の整備、部品交換については、利用者と同意の上で実施し、追加作業の扱いとして、追加費用をいただきます。</li>
              <li>本サービスの対象となる自動車は、自家用乗用車とします。ただし、自家用乗用車であってもトヨタ、ホンダ、日産、マツダ、スバル、スズキ、ダイハツ、三菱自動車以外のメーカー(外車等を含む)、乗車定員11人以上の自動車、乗車定員10人以下で車両総重量8トン以上の自動車、レンタカーおよび特殊自動車、初度登録年から20年以上経過した車両、走行距離が20万km以上の車両は除外します。また、定期点検整備の実施後において、自動車検査証に記載された使用者が変わったもの、あるいは、事業用自動車、レンタカーに該当することとなったものも除外します。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第3条 （車検費用の事前見積り）</h3>
            <ol class="ol-count fs13">
              <li>利用者は、当社所定の方法により、本アプリを通じて、車検の事前見積りを行うことができます。</li>
              <li>本サービスで車検費用の事前見積りを行うには、本アプリへの車検証情報の読み込み、対象車両の走行距離情報、個人情報等の登録が必要となります。なお、本サービスで事前見積り及び車検予約を行う者は、左記情報入力にあたり虚偽のない情報を提供するものとし、入力情報に変更があった場合は速やかに当社所定の変更手続をとるものとします。</li>
              <li>ご案内する事前見積りは目安であり、受付店舗に対象車両をお持ち込み頂いた後、概算見積り金額をお伝えします。この際、車検証や対象車両の状態、納税状況等により別途追加料金が発生する場合や、本サービスの提供ができない場合があります。</li>
              <li>対象車両をお預かり後に、定額整備対象品目以外で新たに安全走行上必要な部品交換や修理箇所が見つかった場合には、作業に入る前に利用者に確認します。当該交換または修理対象部品が、本サービスの定額整備対象品目以外である場合は、追加作業扱いとして、追加料金が発生するものとします。</li>
              <li>見積り金額を訂正させていただく場合には、前項の連絡をもって変更の通知があったものとし、利用者は変更後の金額に同意の上で、当該金額を支払うものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第4条 （車検実施の予約）</h3>
            <ol class="ol-count fs13">
              <li>利用者は、本アプリによる事前見積り実施後、受付店舗から連絡を受け、車検実施日時を取り決めるものとします。来店日時が決定した時点を以て、予約が完了したものとみなします。</li>
              <li>利用者は、本条第1項に定める予約申し込みを行った後、本アプリ上で予約ステータスを必ず確認するものとします。</li>
              <li>利用者が予約を申し込んだ受付店舗または当社から、予約内容確認または変更等のため、電話または電子メール等で連絡をすることがあります。その際に利用者が入力した連絡先が不通などで連絡がとれない場合、利用者の同意を得ることなく予約を取り消す場合があります。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第5条 （車検実施）</h3>
            <ol class="ol-count fs13">
              <li>利用者は、予約した車検実施の予定日時に、受付店舗に対象車両を直接納車するものとします。</li>
              <li>本規約第2条2項の通り、対象車両の納車後、受付店舗にて対象車両の状態確認を行い、概算見積りをお伝えします。整備内容説明及び概算見積りへの利用者の同意を以て、車検実施の契約が成立したものとみなします。</li>
              <li>納車後の状態確認、または車検実施中に、対象車両が受付店舗では車検の受付ができない自動車等であることが判明した場合、車検実施をお引き受けできないことがあります。その場合、利用者は直接受付店舗と対象車両の引き取り予定日を決め、当該予定日の決められた時間に対象車両を引き取るものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第6条 （車検の代金）</h3>
            <ol class="ol-count fs13">
              <li>利用者は、車検終了後、車検の代金を本アプリ上の決済、または現金等、受付店舗が定める方法により、受付店舗に支払うこととします。尚、利用者が正当な理由なく車検代金の支払いを拒否した場合は、対象車両の返却をお断りする場合があります。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第7条 （車検予約の取消し）</h3>
            <ol class="ol-count fs13">
              <li>本規約4条1項、並びに5条2項に基づく利用者による受付店舗への車検実施の予約、または契約の全部もしくは一部の取消し、または車検内容の変更については、受付店舗の定めによるものとし、利用者は、車検実施の予約時に、当該定めを確認するものとします。</li>
              <li>利用者が本車検予約を取消す場合は、利用者と受付店舗で合意した車検実施日の3日前までに、受付店舗に対して本条1項で定める取消しの連絡を行うものとします。</li>
              <li>本条1項の定めにより、車検の取消し、または変更に伴う費用等が発生する場合、利用者はその費用を受付店舗に直接支払うものとします。尚、車検予約の取消しができずユーザーが不利益を被った場合でも当社は一切の責任を負いません。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第8条 （代車の貸し出し） </h3>
            <p class="fs13">代車の貸し出しについては受付店舗の定めによるものとし、利用者は、本規約4条1項に定める車検実施の予約時に、受付店舗に確認するものとします。</p>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第9条 （整備保証）</h3>
            <ol class="ol-count fs13">
              <li>（整備保証の対象範囲）
                <p>整備保証の対象範囲は、道路運送車両法第48条に基づく定期点検整備時に同法に基づく自動車点検整備に定められた項目(以下「定期点検項目」という。）について行った点検・整備作業の内、当社が定める定額整備対象品目、及び追加作業を行った整備・交換部品とします。</p></li>
              <li>（整備保証の期間）
                <p>整備保証の期間は、車検が完了した日から満6ヶ月、または走行距離10,000 kmに達したときのいずれか早い時点までとします。</p></li>
              <li>（整備保証の内容）
                <p>上記対象品目が整備保証期間内に当社の基準に照らして異常、不具合と認めたものについては、無料で整備・交換致します。</p></li>
              <li>（整備保証から除外されるもの）
                <p class="mb0">1） 中古パーツの部品による不具合</p>
                <p class="mb0">2） 客観性のない現象で、個人の感覚に基づく不具合（音、振動等）</p>
                <p class="mb0">3） 事故・災害(冠水・洪水等)による異常、不具合</p>
                <p class="mb0">4） 定期点検整備実施後における弊社以外での自動車の改造および整備による不具合</p>
                <p class="mb0">5） レース、ラリー、過積載等通常の仕様限度を超えて酷使をしたことによる不具合</p>
                <p class="mb0">6） 定期点検整備の項目についての整備作業であって、利用者の指示によって実施しなかったもの</p>
                <p class="mb0">7） 錆を原因とする不具合</p>
              </li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第10条 （禁止事項）</h3>
            <ol class="ol-count fs13">
              <li>利用者は、本規約等を遵守し次の行為を行わないものとします。
              <p class="mb0">1） 本サービスにより知り得た情報を、私的利用以外の目的(営利目的等)で利用する行為、または本アプリを営業活動に利用する行為。</p>
              <p class="mb0">2） 第三者へのいやがらせ、誹謗、中傷、名誉を傷つける行為または猥褻的もしくは暴力的な行為。</p>
              <p class="mb0">3） 真実でない情報を発信する行為または当社へ情報登録を行う際に虚偽の届出をする行為。</p>
              <p class="mb0">4） 有害なコンピュータプログラムを送信する行為、本アプリを不正に改竄する行為、他人になりすます行為、当社・本サービス・第三者に危害や不利益を与える行為もしくは本サービスの運営を妨害する行為、またはそれらのおそれのある行為。</p>
              <p class="mb0">5） 当社および第三者の著作権、特許権、肖像権、商標権等の知的所有権、財産権、プライバシー権その他の権利や信用、名誉を侵害する行為またはそのおそれのある行為。</p>
              <p class="mb0">6） ID等を不正に使用しまたは使用させる行為。</p>
              <p class="mb0">7） 当社が提供する情報を当社の承諾を得ることなく改変する行為。</p>
              <p class="mb0">8） 不正の目的をもって当社が提供する本サービスを利用する行為。</p>
              <p class="mb0">9） 手段を問わず、本サービスの運営を妨害する行為。</p>
              <p class="mb0">10） 選挙活動、またはこれに類する行為、その他の政治および宗教に関する行為。</p>
              <p class="mb0">11） 本規約のいずれかの条項に違反する行為。</p>
              <p class="mb0">12） 法令に違反する行為。</p>
              <p class="mb0">13） 公序良俗に反する行為。</p>
              </li>
              <li>利用者は、前項の規定に違反し、当社および第三者に損害を与えた場合、当該損害を賠償するものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第11条 （利用者の責任等） </h3>
            <ol class="ol-count fs13">
              <li>利用者は、自己の責任の下で、本サービスを利用するものとします。</li>
              <li>利用者と受付店舗との間でトラブル、紛争等が生じた場合は、利用者と受付店舗との間で直接解決するものとします。</li>
              <li>利用者が本規約等に違反し、その結果、利用者または第三者に損害が生じたとしても、当社は一切の責任を負いません。</li>
              <li>当社は、本サービスその他当社のウェブサイト、サーバ、ドメイン等から送られるデータ、プログラム、コンテンツ、電子メール等に、コンピュータウィルス等の有害なものが含まれないことを保証しません。利用者は、自己のパソコン等のデバイスにウィルス対策ソフトをインストールする等、必要な予防措置を講じるものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第12条 （本サービス提供の停止）</h3>
            <ol class="ol-count fs13">
              <li>当社は、利用者が本規約等に違反した場合、もしくは次のいずれかに該当する場合、利用者に事前の通知または催告をすることなく、本サービスの提供を本サービスの提供を一時停止することができます。
                <p class="mb0">1） 利用者に対して、差押、仮差押、仮処分、強制執行または破産の申立てがなされた場合。</p>
                <p class="mb0">2） その他、本サービスの利用者として不適格と当社が判断した場合。</p>
              </li>
              <li>当社は、前項の本サービス提供の停止により、利用者に損害または不利益が生じたとしても、一切責任を負わないものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第13条 （本サービスの変更、中断及び終了）</h3>
            <ol class="ol-count fs13">
              <li>当社は、次のいずれかに該当する場合、利用者に対する事前の通知を行うことなく、本サービスの全部または一部の内容を変更、中断または終了できるものとします。
              <p class="mb0">1） 本サービス提供に必要とする設備およびシステムの定期的または緊急の保守、点検もしくは更新を行う場合</p>
              <p class="mb0">2） システム障害対応またはその他技術上、運用上の理由による場合</p>
              <p class="mb0">3） 天災、火災、停電等不測の事態のために本サービスの継続的な提供が困難となった場合</p>
              </li>
              <li>当社が、営業上、運用上もしくは技術上の理由により本サービスの中断もしくは終了が必要であると判断した場合当社は、利用者が登録している本アプリまたは電子メールアドレス宛に発信する方法、または本サービスのウェブサイト内で表示する方法にて事前の通知を行うことにより、本サービスの提供を終了することができるものとします。</li>
              <li>当社は、本条により本サービスの全部または一部の提供内容を変更、中断または終了した場合、利用者または第三者が被った損害について一切の責任を負わないものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第14条 （個人情報）</h3>
            <p class="fs13">本サービスの利用にあたって利用者が当社に対して個人情報を提供した場合、当社は、別途定める「【コスモの公式】アプリプライバシーポリシー」に従い取り扱うものとし、利用者はこれに同意するものとします。</p>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第15条 （免責事項）</h3>
            <p class="fs13">当社が提供する本サービスを利用する場合、利用者は以下の免責事項に同意したものとみなし、当社は一切の責任を負わないものとします。</p>
            <ol class="ol-count fs13">
              <li>（車両引渡し後の責任）
              <p>受付店舗から利用者へ対象車両または対象車両の鍵を引渡し後は、本規約9条の整備保証の範囲に該当する場合を除いて、原則として対象車両に関する一切の責任を負いかねます。利用者は引渡し時に必ず対象車両の状態を確認するものとします。車両引渡し後のお申し出については一切応じかねます。</p>
              </li>
              <li>（車両の損傷）
              <p>納車時及び引渡し時に相互未確認の対象車両の傷につきましては免責とさせて頂きます。微細な傷、1mの距離から通常の目視確認で判別できない傷については一切を免責とさせて頂きます。相互未確認の傷等の発生の有無に、疑義が生じた場合、中立な調査機関に依頼し、その公正な判断に委ねるものとなります。お預かり中に発生した対象車両の損傷については、当社の責任が明白な場合を除き一切を免責とさせて頂きます。（ランプ類の球切れ、経年劣化等による故障・損壊を含む）また、当社の責任による損傷の補償につきましては、損傷箇所に限ります。補償内容は原状復帰を原則としますが、補修部分を塗装でほぼ原状に修復できる場合には、部品交換などは出来かねます。部品交換が必要な場合は、中古部品を使用することがあります。また、修理は当社指定工場、またはそれに準ずる整備工場で行うものとし、さらに、対象車両の損傷や修理預かりを理由とする二次的損害（売却査定額の減少・営業補償等）についても一切を免責とさせて頂きます。</p>
              </li>
              <li>（対象車両内の遺留品に関して）
              <p>対象車両内の金品・貴重品の紛失等につきましては、全て免責とさせて頂きます｡現金、貴重品、ゴルフバック等は、利用者の責任において、受付店舗に対象車両を預ける前に必ず降ろしてください。対象車両のお預かり後は、当社は対象車両内の遺留品の紛失の申し出など一切を受付しません。</p>
              </li>
              <li>（鍵及びキーホルダー等に関して）
              <p>対象車両の鍵に付いている、その他の鍵やキーホルダー等は必ず取り外して下さい。万一、それらに傷・汚れ又は紛失が起きた場合は、一切を免責とさせて頂きます。</p>
              </li>
              <li>（走行距離に関して）
              <p>お預かり中の対象車両の移動は、車検実施に必要な移動だけに努めますので、走行距離の増加については免責とさせて頂きます｡</p>
              </li>
              <li>（燃料消費に関して）
              <p>対象車両をお預かり中の燃料代につきましては、利用者の負担となります。燃料計残量が5分の1以下の場合は、利用者に事前の通知することなく、受付店舗が必要と判断した燃料油量を補給し、受付店舗が定める金額を、対象車両の引渡し時に利用者に対して請求させて頂く場合があります。</p>
              </li>
              <li>（引渡しのタイミングに関して）
              <p>対象車両の状況により、引渡し日時が当初の予定よりも遅れる場合があります。</p>
              </li>
              <li>（車両の引渡しに関して）
              <p>引渡し予定日時に受け渡し場所に利用者が不在で引渡しできず、受付店舗が対象車両を保管せざるを得ない場合には、引渡し完了までの保管料として受付店舗の定める金額を別途、利用者にご請求する場合があります。</p>
              </li>
              <li>（利用者以外への対象車両の引渡しに関して）
              <p>利用者本人以外の方から対象車両の引渡しの申し出があった場合は､原則として対象車両の引渡しは致しません。但し、利用者本人の委任状または､受付店舗が信憑性のある正当な書類を所持していると判断した第三者が対象車両の引き取りに来た場合には、対象車両を引渡すものとします。尚、左記の場合、対象車両引渡しの判断、並びに対象車両引渡し後の損害、損失については全て免責とさせて頂きます｡</p>
              </li>
              <li>（窓ガラス・ボディー・レンズ類に関して）
              <p>お預かり中の飛石やワイパーによりフロントガラス、その他ガラス、レンズ類及びボディー等に傷がついた場合（晴天時にワイパーを動かしてしまった場合の損傷も含みます）、及び、フィルムの貼られたフロントガラスの車検標章や点検整備済みステッカーの貼り換えに伴うフィルムの傷や剥がれが生じた場合につきましては一切免責とさせて頂きます。</p>
              </li>
              <li>（盗難に関して）
              <p>お預かりした対象車両が盗難に遭った場合､補償の範囲は受付店舗の定めに従うものとします。</p>
              </li>
              <li>（交通事故等による責任に関して）
              <p>当社の都合による対象車両移動中の交通事故などによる損傷、破損が生じた場合、補償の範囲は受付店舗の定めによるものとします。</p>
              </li>
              <li>（天災地変その他に関して）
              <p>天災地変､地震、台風､洪水､雪､雹､落雷､その他暴動等、当社の責任範囲外の責めによって対象車両に損傷が生じた場合は、全て免責とさせて頂きます｡</p>
              </li>
              <li>（仮ナンバーの取付に関して）
              <p>対象車両が車検切れで自走不可能な場合、既存のナンバープレート取付位置へ仮ナンバーをボルト固定致します。これに伴う取付位置周辺ボディーや既存のナンバープレート及びボルトに対する多少の傷等につきましては免責とさせて頂きます。</p>
              </li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第16条 （損害賠償）</h3>
            <ol class="ol-count fs13">
              <li>利用者が本規約等に違反した場合、または利用者の故意・過失により当社に損害や費用負担を生じさせた場合、利用者は当社に対して発生した損害または費用（弁護士費用を含む）を賠償する義務を負うものとします。</li>
              <li>利用者は、本サービス利用によって第三者に対して損害を与えた場合、自己の責任において解決し、当社に損害を与えないものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第17条 （規約の改定）</h3>
            <p class="fs13">当社は､自己の裁量によりいつでも本規約等を改定することができます｡改定後の本規約等は当社が当社所定の本アプリ上または本サービスのウェブサイト上に掲示した時に効力を生じ､利用者が本規約等の改定後に本サービスを利用した場合は改定後の本規約等に同意したものとみなします。</p>
          </section>

          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第18条 （管轄裁判所）</h3>
            <p class="fs13">本規約等は日本国内法に基づき解釈されるものとし、本サービスに関連して訴訟の必要が生じた場合には、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>

            <p class="fs13 pt16">以上</p>
          </section>

        </section>

        <section class="section white-panel mb2p pt24">
          <h2 class="fs16 bdb-solid-gradient1 pb8 mb8">特定商取引法に基づく表記</h2>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■事業者の名称</h3>
            <p class="fs13">コスモ石油マーケティング株式会社</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■事業者の所在地</h3>
            <p class="fs13">〒104-8323 東京都中央区京橋１－７－１</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■事業者の法人代表者</h3>
            <p class="fs13">髙山 直樹</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■事業者の代表番号</h3>
            <p class="fs13">0120-530-372</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■販売価格（車検代金）</h3>
            <p class="fs13">コスモ石油マーケティング株式会社が管理する本アプリ上で、車検の事前見積りを行うことができます。</p>
            <p class="fs13">本アプリ上で事前見積りを行った後、車検対象となっている自動車を指定した店舗に持ち込み、受付店舗では引き受け時に店頭で対象車両を点検して整備作業と見積金額を確定するため、本アプリ上の見積金額と確定金額には差が生じる可能性があります。</p>
            <p class="fs13">なお、車検に関する法定費用は車検代金に含まれており、車検完了後の自動車のお引渡しにかかる費用（納車費用）は代金に含まれています。</p>
            <p class="fs13">当社が別途「定額整備対象品目」にて定める整備対象品目(以下、定額整備対象品目という)の整備、部品交換費用については原則定額ですが、定額整備対象品目以外の整備、部品交換については、利用者と同意の上で実施し、追加作業の扱いとして追加費用をいただきます。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■代金の支払時期・支払方法</h3>
            <p class="fs13">車検代金の支払方法については、本アプリ上で「クレジットカード支払い」または「店頭で現金支払い」から選択することができます。</p>
            <p class="fs13">また、お支払日は、車検終了後、本アプリ上の決済でいつでもお支払い頂けます。</p>
            <p class="fs13">引渡し当日に店頭で現金でお支払い頂くことも可能です。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■契約の締結</h3>
            <p class="fs13">対象車両を受付店舗に納車後、受付店舗にて対象車両の状態確認を行い、整備内容及び概算見積りをお伝えします。</p>
            <p class="fs13">整備内容説明及び概算見積りへの利用者の同意を以て車検代金を確定させ、車検実施の契約が成立したものとみなします。</p>
            <p class="fs13">なお納車後の状態確認、または車検実施中に、対象車両が受付店舗では車検の受付ができない自動車であることが判明した場合、車検実施をお引き受けできないことがあります。</p>
            <p class="fs13">その場合、利用者は直接受付店舗と対象車両の引き取り予定日を決め、当該予定日の決められた時間に対象車両を引き取るものとします。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■サービスの提供時期</h3>
            <p class="fs13">車検実施の契約が成立後、対象車両を納車いただいた時点から車検サービスの提供が開始されます。車検実施後、対象車両の引渡しを以て車検サービスの提供が完了します。</p>
            <p class="fs13">また、整備保証の対象範囲は、道路運送車両法第48条に基づく定期点検整備時に同法に基づく自動車点検整備に定められた項目について行った点検・整備作業の内、定額整備対象品目、及び追加作業を行った整備・交換部品とします。</p>
            <p class="fs13">整備保証の期間は、車検が完了した日から満6ヶ月、または走行距離10,000 kmに達したときのいずれか早い時点までとします。</p>
            <p class="fs13">上記対象品目が整備保証期間内に当社の基準に照らして異常、不具合と認めたものについては、無料で整備・交換致します。</p>
            <p class="fs13">以下の場合には整備保証対象から除外されます。</p>
              <p class="mb0">1） 中古パーツの部品による不具合</p>
              <p class="mb0">2） 客観性のない現象で、個人の感覚に基づく不具合（音、振動等）</p>
              <p class="mb0">3） 事故・災害(冠水・洪水等)による異常、不具合</p>
              <p class="mb0">4） 定期点検整備実施後における弊社以外での自動車の改造および整備による不具合</p>
              <p class="mb0">5） レース、ラリー、過積載等通常の仕様限度を超えて酷使をしたことによる不具合</p>
              <p class="mb0">6） 定期点検整備の項目についての整備作業であって、利用者の指示によって実施しなかったもの</p>
            <p class="fs13"></p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■車検実施の申込みの撤回または解約</h3>
            <p class="fs13">契約の全部もしくは一部の取消し、または車検内容の変更については受付店舗の定めによって取消料が発生する可能性があるため、車検実施の予約時に受付店舗にご確認ください。</p>
            <p class="fs13">利用者が本車検予約を取消す場合は、利用者と受付店舗で合意した車検実施日の3日前までに、受付店舗に対して取消しの連絡を行うものとします。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■販売価格、送料等以外に購入者等が負担すべき金銭</h3>
            <p class="fs13">車検完了後、引渡し予定日時に受け渡し場所に利用者が不在で引渡しできず、受付店舗が対象車両を保管せざるを得ない場合には、引渡し完了までの保管料として受付店舗の定める金額を別途、利用者にご請求する場合があります。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">■免責事項</h3>
            <p class="fs13">詳しくは、コミっと車検利用規約(第15条) をご参照ください。(※)</p>
          </section>
        </section>

      </article>
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: [
  ],
  methods: {
  },
  async mounted () {
    this.nativePVset('SHAKEN_KOKANKIJYUN')
    $(function () {
      $('.dl-toggle > .child').hide()
      $('.dl-toggle').click(
        function (l) {
          $(this).toggleClass('open')
          $('.child', this).slideToggle(500)
        })
    })
  }
}
</script>
